export default [
  {
    title: 'History',
    icon: 'ClockIcon',
    tagVariant: 'light-success',
    route: 'history'
  },
]
